import { Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { updateParamsQuoteDetail } from 'src/redux/actions/paramsQuoteDetailAction';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { useDispatch } from 'react-redux';
import { isValidUrl } from 'src/utils/valid';
import { toggleEditQuoteSelector } from 'src/redux/selectors/toggleEditQuoteSelector';
import { paramsQuoteDetailSelector } from 'src/redux/selectors/paramsQuoteDetailSelector';

const Lifetime: React.FC = () => {
    const dispatch = useDispatch();
    const { safariLink } = useSelector(quoteDetailSelector);
    const { safariLink: safariLinkParam } = useSelector(
        paramsQuoteDetailSelector,
    );
    const isEdit = useSelector(toggleEditQuoteSelector);

    const [inputValue, setInputValue] = useState<string>('');
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        const link = (safariLinkParam ?? safariLink) || '';
        setInputValue(link);
        const valid = isValidUrl(link);
        setIsError(!valid);
    }, [safariLink, safariLinkParam]);

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            let value = e.target.value;
            setInputValue(value);
            const valid = isValidUrl(value);
            setIsError(!valid);

            dispatch(
                updateParamsQuoteDetail({ safariLink: valid ? value : '' }),
            );
        },
        [dispatch],
    );

    return (
        <div className="card lifetime">
            <div className="header">Your Lifetime Golf Trip Awaits</div>
            <p>
                The information you need for your upcoming trip is ready to
                view.
            </p>
            <a
                href={inputValue || '#'}
                className="btn-pay"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => {
                    if (isError) {
                        e.preventDefault();
                    }
                }}
                {...(isError && { style: {opacity: 0.5, cursor: "no-drop"} })}
            >
                View your Tournament Experience
            </a>
            {isEdit && (
                <Input
                    className="input"
                    variant="borderless"
                    placeholder="Enter your link here"
                    defaultValue={safariLink}
                    onChange={handleInputChange}
                    value={inputValue}
                    status={!isError ? '' : 'error'}
                />
            )}
        </div>
    );
};

export default Lifetime;
